import selectIsAuthenticated from 'selectors/selectIsAuthenticated.selector';
import { selectMainToken } from 'utils/cognito.util';
import isTruthy from 'utils/predicates/isTruthy.util';

const selectIsLoggedIn = (state) => {
  const auth = selectIsAuthenticated(state);
  if (auth === null) {
    // if in the process of logging in, the value should be neither true nor false
    // null is the chosen placeholder for "not enough data yet"
    return null;
  }

  const token = selectMainToken(state);

  return isTruthy(auth && token);
};

// noinspection JSUnusedGlobalSymbols
export default selectIsLoggedIn;
